<template>
    <div class="AdminHome">
        <AdminHeader/>
        <router-view class="HomeBody" />
    </div>
</template>
<script>
import AdminHeader from '@/views/AdminHeader'
export default {
    components: {AdminHeader},
	data() {
		return {
		};
	},
    created() {
    },
    mounted(){
    },
    methods: {
    },
    beforeDestroy() {
    }
};
</script>
<style lang="less">
.AdminHome {
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
    width:100vw;
    height:100vh;
    .AdminHeader{
        width:100%;
        // position:absolute;
        // top:0px;
    }
    .HomeBody{
        width:100%;
        overflow-x: hidden;
        overflow-y: auto;
        flex:1;
        padding-top: 10px;
        background-color: #E5ECFF;
    }
    .AdminBottom{
        height:55px;
        width:100%;
        box-shadow: 0px 0px 10px 0px #ccc;
        display:flex;
        justify-content: center;
        align-items: center;
        // position:absolute;
        // bottom:0px;
        background-color:#F2F6FF;
        .tabs{
            width:100%;
        }
    }
}
</style>